import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { MqttMessage } from '../../types';

interface MqttState {
    messages: MqttMessage[];
    connectionStatus: boolean;
}

const initialState: MqttState = {
    messages: [],
    connectionStatus: false,
};

export const mqttSlice = createSlice({
    name: 'mqtt',
    initialState,
    reducers: {
        addMessage: (state, action: PayloadAction<MqttMessage>) => {
            state.messages.push(action.payload);
        },
        setConnectionStatus: (state, action: PayloadAction<boolean>) => {
            state.connectionStatus = action.payload;
        },
    },
});

export const { addMessage, setConnectionStatus } = mqttSlice.actions;
